import { defineField, defineType } from 'sanity'
import { richTextContent } from '../../data/richText'

export default defineType({
  name: 'accessoryCategory',
  title: 'Accessory Category',
  type: 'document',
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      description: 'For Sanity Studio internal use',
    }),
    defineField({
      name: 'heading',
      title: 'Heading',
      type: 'string',
      validation: (rule) => rule.required(),
    }),
    defineField({
      name: 'discountLabel',
      title: 'Discount label',
      type: 'string',
      description: 'If entered, will display next to the title',
    }),
    defineField({
      name: 'accessories',
      title: 'Accessories',
      type: 'array',
      of: [
        {
          name: 'accessoryBundle',
          title: 'Accessory Bundle',
          type: 'reference',
          to: [
            {
              type: 'accessoryBundle',
            },
          ],
        },
      ],
      validation: (rule) => [rule.min(1), rule.required()],
    }),
    defineField({
      name: 'additionalInfo',
      title: 'Additional Info',
      type: 'object',
      options: {
        collapsible: true,
        collapsed: true,
      },
      fields: [
        defineField({
          name: 'label',
          title: 'Label',
          type: 'string',
          initialValue: 'Learn More',
          description: 'Button label that opens the info modal',
        }),
        defineField({
          name: 'content',
          title: 'Content',
          type: 'array',
          of: richTextContent,
          description: 'Content displayed in the modal',
        }),
      ],
    }),
  ],
  preview: {
    select: {
      title: 'heading',
      subtitle: 'name',
    },
    prepare({ title, subtitle }) {
      return {
        title: title || 'Untitled',
        subtitle: subtitle || 'Accessory Category',
      }
    },
  },
})
